import React from 'react';

class LegendInfo extends React.Component {

    render() {
        let info = []
        for (const key in this.props.legendInfo) {
            info.push(<div key={key} className='d-flex py-2 px-2'>
                        <div className='color-square right-layout' 
                            style={{ backgroundColor: this.props.legendInfo[key].color }}>
                        </div>
                        <p className='text-color pl-2 m-0'>{ this.props.legendInfo[key].description }</p>
                    </div>)
        }
        return(
            <div>
                {info}
            </div>
        );
    } 
}

export default LegendInfo;